module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Ka-Lc.6a1fc74e.png";